import { LinearGradient } from 'expo-linear-gradient';
import React, { Component } from 'react';
import i18n from 'i18n-js';
import {
  Dimensions, ImageBackground, Text, TouchableOpacity, View
} from 'react-native';
import globalStyles from '../../style/global';
import styles from '../../style/scanpack';
import promptStyle from '../../style/popupmodel';
import StyledInput from '../../commons/Inputs/stylesInput';
import CamScanner from '../camScanning/CamScanner';
import { Ionicons } from '@expo/vector-icons';
import { withCameraScanner } from '../../helpers/withCameraScanner';

class PropmtBarcode extends Component {
  constructor(props) {
    super(props);
    this.state = {
      windowWidth: Dimensions.get('window').width,
      barcodefouc: null,
    };
    this.barcodefouc = React.createRef();
  }

  handleCameraScan = (scannedValue) => {
    this.props.cameraHook.closeCamera();
    if (scannedValue && this.props.onChangeBarcode) {
      this.props.onChangeBarcode(scannedValue);
      setTimeout(() => {
        if (this.props.update) {
          this.props.update();
        }
      }, 100);
    }
  };

  updateDimensions = () => {
    this.setState({ windowWidth: window.innerWidth });
  };
  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions);
    if (document.body) {
      document.body.style.height = this._originalBodyHeight || '';
    }
  }
  componentDidUpdate = () => {
    if (!this.props.cameraHook.showCameraScanner) {
      this.barcodefouc.current.focus();
    }
    this._updateBodyHeight();
  };
  componentDidMount() {
    window.addEventListener('resize', this.updateDimensions);
    if (document.body) {
      this._originalBodyHeight = document.body.style.height;
    }
    this._updateBodyHeight();
  }
  _updateBodyHeight = () => {
    requestAnimationFrame(() => {
      if (document.body && document.documentElement) {
        const scrollHeight = Math.max(
          document.body.scrollHeight,
          document.documentElement.scrollHeight
        );
        document.body.style.height = scrollHeight + 'px';
      }
    });
  };
  render() {
    return (
      <>
        <View style={{ width: '100%', flex: 1, backgroundColor: '#f5ab2b' }}>
          <ImageBackground
            style={{ flex: 1, zIndex: 999, minHeight: '100%' }}
            source={require('././../../../assets/Left_new2.jpg')}>
            <View
              style={{
                textAlign: 'center',
                justifyContent: 'center',
                width: '100%',
                zIndex: 999,
                position: 'absolute'
              }}>
              {this.props.openPromptBarcode === true ? (
                <LinearGradient
                  locations={[0, 1]}
                  start={{ x: 0, y: 1 }}
                  end={{ x: 0, y: 0 }}
                  colors={['#d47d02', '#ffb636']}
                  style={[
                    promptStyle.promptModel,
                    {
                      width: this.state.windowWidth >= 600 ? '60%' : '81%',
                      left: this.state.windowWidth >= 600 ? '20%' : '10%'
                    }
                  ]}>
                  <View
                    testID='openPromptBarcode'
                    style={{
                      flexDirection: 'row',
                      alignItems: 'center',
                      width: '100%',
                    }}>
                    <View style={{ width: 30 }} />
                    <View style={{ flex: 1, alignItems: 'center' }}>
                      <Text style={[styles.scanRecordCountText]}>
                        {i18n.t('product.unique_bar')}
                      </Text>
                    </View>
                    <TouchableOpacity
                      testID='iconCancel'
                      onPress={() => this.props.closePrompt()}
                      style={{ width: 30, alignItems: 'center' }}>
                      <i
                        className="icon-cancel"
                        style={{
                          fontSize: '26px',
                          color: '#4b4132',
                        }}></i>
                    </TouchableOpacity>
                  </View>
                  <View
                    style={{
                      alignItems: 'center',
                      justifyContent: 'center',
                      width: '100%'
                    }}>
                    <View style={{ alignItems: 'center', width: '80%' }}>
                      <StyledInput
                        style={[promptStyle.promptTextIn, { border: 'none' }]}
                        autoFocus={true}
                        ref={this.barcodefouc}
                        onSubmitEditing={() => this.props.update()}
                        onChangeText={text => {
                          this.props.onChangeBarcode(text);
                        }}
                        inputStyle={{ height: '100%', fontSize: 20, padding: 10 }}
                        useInputStyle={false}
                      />
                      {this.props.cameraHook.camScannerEnabled && (
                        <TouchableOpacity
                          testID="cameraScanBtn"
                          style={{
                            position: 'absolute',
                            right: -15,
                            top: 0,
                            bottom: 0,
                            justifyContent: 'center',
                          }}
                          onPress={this.props.cameraHook.openCamera}>
                          <Ionicons
                            name="camera"
                            size={24}
                            color="#4b4132"
                          />
                        </TouchableOpacity>
                      )}
                    </View>
                    {this.props.cameraHook.camScannerEnabled && this.props.cameraHook.showCameraScanner && (
                      <View style={{ width: this.state.windowWidth > 900 ? '60%' : this.state.windowWidth > 600 ? '80%' : '100%', alignSelf: 'center', marginBottom: 15 }}>
                        <CamScanner
                          inline={true}
                          onScan={this.handleCameraScan}
                          onClose={this.props.cameraHook.closeCamera}
                        />
                      </View>
                    )}
                    <View style={{ flexDirection: 'row' }}>
                      <TouchableOpacity
                        testID='cancelButton'
                        style={[promptStyle.promptButton, { marginLeft: '-50%' }]}
                        onPress={() => {
                          this.props.closePrompt();
                        }}>
                        <Text>Cancel</Text>
                      </TouchableOpacity>
                      <TouchableOpacity
                        testID='EnterButton'
                        style={[promptStyle.promptButton, { marginLeft: '100%' }]}
                        onPress={() => this.props.update()}>
                        <Text>Enter</Text>
                      </TouchableOpacity>
                    </View>
                  </View>
                </LinearGradient>
              ) : (
                <LinearGradient
                  locations={[0, 1]}
                  start={{ x: 0, y: 1 }}
                  end={{ x: 0, y: 0 }}
                  colors={['#d47d02', '#f5ab2b']}
                  style={[
                    promptStyle.promptModel,
                    {
                      width: this.state.windowWidth >= 600 ? '60%' : '81%',
                      left: this.state.windowWidth >= 600 ? '20%' : '10%'
                    }
                  ]}>
                  <View
                    style={{
                      flexDirection: 'row',
                      alignItems: 'center',
                      width: '100%',
                    }}>
                    <View style={{ width: 30 }} />
                    <View style={{ flex: 1, alignItems: 'center' }}>
                      <Text style={[styles.scanRecordCountText]}>
                        {i18n.t('product.unique_sku')}
                      </Text>
                    </View>
                    <TouchableOpacity
                      testID='iconCancel'
                      onPress={() => this.props.closePrompt()}
                      style={{ width: 30, alignItems: 'center' }}>
                      <i
                        className="icon-cancel"
                        style={{
                          fontSize: '26px',
                          color: '#4b4132',
                        }}></i>
                    </TouchableOpacity>
                  </View>
                  <View
                    style={{
                      alignItems: 'center',
                      justifyContent: 'center',
                      width: '100%'
                    }}>
                    <View style={{ alignItems: 'center', width: '80%' }}>
                      <StyledInput
                        style={[promptStyle.promptTextIn, { border: 'none' }]}
                        ref={this.barcodefouc}
                        autoFocus={true}
                        onSubmitEditing={() => this.props.update()}
                        onChangeText={text => {
                          this.props.onChangeSku(text);
                        }}
                        inputStyle={{ height: '100%', fontSize: 20, padding: 10 }}
                        useInputStyle={false}
                      />
                    </View>
                    <View style={{ flexDirection: 'row' }}>
                      <TouchableOpacity
                        testID='cancelButton'
                        style={[promptStyle.promptButton, { marginLeft: '-50%' }]}
                        onPress={() => {
                          this.props.closePrompt();
                        }}>
                        <Text>Cancel</Text>
                      </TouchableOpacity>
                      <TouchableOpacity
                        testID='EnterButton'
                        style={[promptStyle.promptButton, { marginLeft: '100%' }]}
                        onPress={() => {
                          this.props.update();
                        }}>
                        <Text>Enter</Text>
                      </TouchableOpacity>
                    </View>
                  </View>
                </LinearGradient>
              )}
            </View>
          </ImageBackground>
        </View>
      </>
    );
  }
}

export default withCameraScanner('promptBarcode')(PropmtBarcode);
